export class itemList {
  id: number = 0;
  optionid: string | undefined;
  answer: any;
  selected: boolean | undefined;
}

export class dataList {
  listName: string | undefined;
  listValue: string | undefined;
}

export class dataLists {
  question: string | undefined;
  dataItems: dataList[] = [];
  required: boolean = false;
}

export class ComponentItemList {
  id: number | undefined;
  optionid: string | undefined;
  formControlName: string | undefined;
  headerName: string | undefined;
  textValue: string | undefined;
  required: boolean | undefined;
  allowScoring: boolean | undefined;
  scoringValue: string | undefined;

  constructor(
    Id?: number,
    FormControlName?: string,
    HeaderName?: string,
    TextValue?: string,
    isRequired?: boolean,
    allowScoring?: boolean,
    scoringValue?: string
  ) {
    this.id = Id;
    this.formControlName = FormControlName;
    this.headerName = HeaderName;
    this.textValue = TextValue;
    this.required = isRequired;
    this.allowScoring = allowScoring;
    this.scoringValue = scoringValue;
  }
}
